import { GetVehicleFuelQueryResponseType } from '@/common/queries/selections/getVehicleFuel/getVehicleFuelQuery.type';
import { fetchApi } from '@/config/axiosSetting';

export const getVehicleFuelFunction = (): Promise<
  GetVehicleFuelQueryResponseType[]
> => {
  return fetchApi.get('/selection_item/vehicle_fuel/wop_list/');
};
